import { axios } from '@/utils/request';
// 大屏接口
// 供应商筛选框
export function getSupplier(params) {
  return axios({
    url: '/service/personal_portrait/info/supplier',
    method: 'get',
    params,
  });
}
// 作业员筛选框
export function getUid(params) {
  return axios({
    url: '/service/personal_portrait/info/uid',
    method: 'get',
    params,
  });
}
// 产线筛选框
export function getProductLine(params) {
  return axios({
    url: '/service/personal_portrait/info/product_line',
    method: 'get',
    params,
  });
}
// 人员概览信息
export function getDetail(params) {
  return axios({
    url: '/service/personal_portrait/info/user/detail',
    method: 'get',
    params,
  });
}
// 人员出勤统计
export function getAttendance(params) {
  return axios({
    url: '/service/personal_portrait/info/user/attendance',
    method: 'get',
    params,
  });
}
// 各指标分数
export function getScore(params) {
  return axios({
    url: '/service/personal_portrait/info/user/score',
    method: 'get',
    params,
  });
}
// // 各指标数量及标准
// getMetrics(params) {
//   return axios({
//     url: '/service/personal_portrait/info/user/metrics',
//     method: 'get',
//     params,
//   });
// },
// 各指标预警数量
export function getWarn(params) {
  return axios({
    url: '/service/personal_portrait/info/user/warn',
    method: 'get',
    params,
  });
}
// 各指标排名情况
export function getRank(params) {
  return axios({
    url: '/service/personal_portrait/info/user/rank',
    method: 'get',
    params,
  });
}
// 质量-学考联动统计
export function getDispatch(params) {
  return axios({
    url: '/service/personal_portrait/info/user/dispatch',
    method: 'get',
    params,
  });
}
// 质量-错误场景统计
export function getDispatchError(params) {
  return axios({
    url: '/service/personal_portrait/info/user/dispatch/error',
    method: 'get',
    params,
  });
}
// 理论-考试通过率
export function getPassRate(params) {
  return axios({
    url: '/service/personal_portrait/info/user/examination/pass_rate',
    method: 'get',
    params,
  });
}
// 实践-达标周期
export function getPractice(params) {
  return axios({
    url: '/service/personal_portrait/info/user/practice',
    method: 'get',
    params,
  });
}
// 技能-技能数量
export function getSkill(params) {
  return axios({
    url: '/service/personal_portrait/info/user/skill',
    method: 'get',
    params,
  });
}
// 积极-问题数量
export function getActive(params) {
  return axios({
    url: '/service/personal_portrait/info/user/active',
    method: 'get',
    params,
  });
}
// 稳定-周环比波动
export function getStable(params) {
  return axios({
    url: '/service/personal_portrait/info/user/stable',
    method: 'get',
    params,
  });
}
// 人员基础档案信息
export function getBaseArchives(params) {
  return axios({
    url: '/service/personal_portrait/info/user/base/archives',
    method: 'get',
    params,
  });
}
// 人员技能履历-项目信息
export function getHistoryProject(params) {
  return axios({
    url: '/service/personal_portrait/info/user/history/project',
    method: 'get',
    params,
  });
}
// 人员技能履历-作业情况
export function getHistoryWork(params) {
  return axios({
    url: '/service/personal_portrait/info/user/history/work',
    method: 'get',
    params,
  });
}
